<template>
    <div class="container-main-body">
        <div class="list-container">
            <div v-if="searchShow" class="search-container">
                <el-row>
                    <el-col :span="6">
                    <div class="search-form-label">样本册：</div>
                    <div class="search-form-controller">
                      <el-input size="mini" placeholder="样本册" clearable v-model="queryData.product_name"></el-input>
                    </div>
                    </el-col>
                    <el-col :span="6">
                    <div class="search-form-label">次数：</div>
                    <div class="search-form-controller">
                        <el-select v-model="queryData.by_count" size="mini">
                            <el-option v-for="item in by_countArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                    </el-col>
                    <el-col :span="6">
                    <div class="search-form-label">外库：</div>
                    <div class="search-form-controller">
                        <el-input size="mini" placeholder="外库" clearable v-model="queryData.external_name"></el-input>
                    </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" style="text-align: center;">
                    <el-button type="warning" size="mini" icon="el-icon-search" plain @click="searchHandler" >开始搜索</el-button>
                    <el-button type="primary" size="mini" icon="el-icon-delete" plain @click="searchHandler('clear')" >清空</el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close" plain @click="showSearchHandler()" >关闭搜索</el-button>
                    </el-col>
                </el-row>
            </div>
            <div class="list-btns-container">
                <el-button-group>
                    <el-button
                    v-for="btn in $store.state.currentLBtnList"
                    :key="btn.id"
                    :type="btn.button_type"
                    size="mini"
                    :icon="btn.button_icon"
                    @click="handlerButtonDispatch(btn.fn)"
                    >{{ btn.button_name }}</el-button>
                </el-button-group>
            </div>
            <!--列表数据 开始-->
            <div class="el-table-container">
                <el-table
                :data="ds"
                size="mini"
                stripe
                border
                height="100%"
                style="width: 100% border:1px solid #d1d1d1"
                header-row-class-name="list-header-row"
                row-class-name="list-row">
                    <el-table-column label="" align="center">
                        <el-table-column label="样本册" prop="product_name" width="170" align="center"></el-table-column>
                        <el-table-column label="出库类别" prop="outstore_type" width="60" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.outstore_type === '1'">正常出库</span>
                                <span v-if="scope.row.outstore_type === '2'">弃用出库</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="外库" prop="external_name" width="50" align="center"></el-table-column>
                        <el-table-column label="分区" prop="partition_name" width="40" align="center"></el-table-column>
                        <el-table-column label="类型" prop="transport_type" width="60" align="center"></el-table-column>
                        <el-table-column label="托盘种类" prop="pallet_type" width="60" align="center"></el-table-column>
                    </el-table-column>
                    <el-table-column label="计划" align="center">
                        <el-table-column label="托盘数量" prop="plan_pallet_num" width="60" align="center"></el-table-column>
                        <el-table-column label="箱子数量" prop="plan_box_num" width="60" align="center"></el-table-column>
                        <el-table-column label="笼子数量" prop="plan_cage_num" width="60" align="center"></el-table-column>
                        <el-table-column label="操作人" prop="plan_creater_name" width="70" align="center"></el-table-column>
                        <el-table-column label="操作时间" prop="plan_create_time" width="120" align="center"></el-table-column>
                    </el-table-column>
                    <el-table-column label="第一次出库" align="center">
                        <el-table-column label="托盘数量" prop="actual_first_pallet_num" width="60" align="center"></el-table-column>
                        <el-table-column label="箱子数量" prop="actual_first_box_num" width="60" align="center"></el-table-column>
                        <el-table-column label="笼子数量" prop="actual_first_cage_num" width="60" align="center"></el-table-column>
                        <el-table-column label="异常原因" prop="first_exception_result" width="120" align="center"></el-table-column>
                        <el-table-column label="操作人" prop="creater_name" width="50" align="center"></el-table-column>
                        <el-table-column label="操作时间" prop="create_time" width="120" align="center"></el-table-column>
                    </el-table-column>
                    <el-table-column label="第二次出库" align="center">
                        <el-table-column label="托盘数量" prop="actual_second_pallet_num" width="60" align="center"></el-table-column>
                        <el-table-column label="箱子数量" prop="actual_second_box_num" width="60" align="center"></el-table-column>
                        <el-table-column label="笼子数量" prop="actual_second_cage_num" width="60" align="center"></el-table-column>
                        <el-table-column label="异常原因" prop="second_exception_result" width="120" align="center"></el-table-column>
                        <el-table-column label="操作人" prop="updater_name" width="50" align="center"></el-table-column>
                        <el-table-column label="操作时间" prop="update_time" width="120" align="center"></el-table-column>
                    </el-table-column>
                    <el-table-column></el-table-column>
                </el-table>
            </div>
            <div class="pagination-container">
                <el-pagination
                background
                :current-page="queryData.pn"
                :page-size="queryData.pageSize"
                :total="queryData.totalCount"
                :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="pageSizeChange"
                @current-change="pageChange"
                ></el-pagination>
            </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    data: function() {
        return {
            ds: [],
            queryData: {
                product_name: "",
                by_count: "",
                external_name: "",
                pn: 1, // 页码
                pageSize: 20, // 每页条数
                totalCount: 0 // 数据总条数
            },
            by_countArray:[{id:'第一次',name:'第一次'},{id:'第二次',name:'第二次'}],
            searchShow: false,
        };
    },
    created: function() {},
    mounted: function() {
        this.loadData();
    },
    methods: {
      // 按钮 点击 调度方法
      handlerButtonDispatch: function(fn, args) {
        var _this = this;
        if (typeof _this[fn] === "function") {
          _this[fn].apply(_this, args);
        } else {
          console.log("warning: the method is not exist");
        }
      },
      // 加载数据
      loadData: function() {
        let _this = this;
        _this.post(_this.$apis.getScanOutRecord, this.queryData, function(
          res
        ) {
          let _json = res.data;
          if (_json.status && _json.status === "logout") {
            _this.logout();
          } else {
            _this.ds = _json.datalist;
            _this.queryData.totalCount = _json.totalCount;
          }
        });
      },
      searchHandler: function(_type) {
        this.queryData.pn = 1;
        if (_type === "clear") {
          this.queryData.by_count = "";
          this.queryData.product_name = "";
          this.queryData.external_name = "";
        }
        this.loadData();
      },
      showSearchHandler: function() {
        this.searchShow = !this.searchShow;
      },
      // 刷新事件
      refreshHandler: function() {
        this.loadData();
      },
      // 页码改变
      pageSizeChange: function(pageSize) {
        this.queryData.pn = 1;
        this.queryData.pageSize = pageSize;
        this.loadData();
      },
      pageChange: function(pn) {
        this.queryData.pn = pn;
        this.loadData();
      }
    },
    components: {
    }
};
</script>
  